export default __webpack_public_path__ + "static/media/lunch1.1e64546f.png";